export function addArrow(newArrow, queue) {
  if (queue.indexOf(newArrow) !== -1) {
    return queue;
  }
  return [newArrow, ...queue];
}

export function removeArrow(removeArrow, queue) {
  return queue.filter(d => d !== removeArrow);
}